import { Navigate, useLocation } from "react-router-dom";

// Royal Momentum's reset-password screen is registered at the top level of both
// shells rather than inside the `/royal-momentum/*` tree, so the URL is a single
// flat segment. Nothing about the screen needs the Momentum tree — it has no
// NavBar, no market/brand state and, by definition, no session — and keeping it
// out of that tree keeps it clear of the session gate in `RoyalMomentum.jsx`.
const MOMENTUM_RESET_PASSWORD_ROUTE = "/royal-momentum-reset-password";

const LEGACY_ROUTE = /^\/royal-momentum\/reset-password/i;

// Reset links already emailed carry the old nested URL, so it keeps working:
// the prefix is rewritten and the `:token/:id` and `/es` tail rides along
// untouched. Case-insensitive because React Router matches routes that way.
const LegacyResetPasswordRedirect = () => {
    const location = useLocation();
    const target = location.pathname.replace(LEGACY_ROUTE, MOMENTUM_RESET_PASSWORD_ROUTE);

    return <Navigate to={`${target}${location.search}`} replace />;
};

export default LegacyResetPasswordRedirect;
